import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const Navbar = () => {
  const { authenticated, role, logout, user } = useAuth();
  const navigate = useNavigate();

  const isAdmin = role === 'ADMIN';
  const isAssinante = role === 'ASSINANTE';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav style={{ 
      padding: '1.2rem 8%', 
      background: '#020617', 
      display: 'flex', 
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
        <Link to="/" style={{ 
          fontFamily: '"Bryndan Write", cursive', 
          color: 'white', 
          textDecoration: 'none', 
          fontWeight: '800', 
          fontSize: '1.8rem' 
        }}>
          Quita<span style={{ color: '#10b981' }}>Go</span>
        </Link>

        <div style={{ display: 'flex', gap: '20px' }}>
          {isAdmin && <Link to="/admin" className="nav-link-item">Painel Mestre</Link>}
          {isAssinante && <Link to="/dashboard" className="nav-link-item">Dashboard</Link>}
        </div>
      </div>

      <div>
        {!authenticated ? (
          <Link to="/login" style={{ 
            background: '#10b981', 
            color: '#022c22', 
            padding: '10px 24px', 
            borderRadius: '8px', 
            textDecoration: 'none', 
            fontWeight: '700' 
          }}>Entrar</Link>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span style={{ color: '#94a3b8' }}>{user?.nome}</span>
            <button onClick={handleLogout} style={{ 
              background: 'transparent', 
              border: '1px solid #ef4444', 
              color: '#ef4444', 
              padding: '6px 16px', 
              borderRadius: '6px', 
              cursor: 'pointer' 
            }}>Sair</button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;